import { render, staticRenderFns } from "./see_video_list_form.vue?vue&type=template&id=3c8a8cec"
import script from "./see_video_list_form.vue?vue&type=script&lang=js"
export * from "./see_video_list_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports